import { render, staticRenderFns } from "./STextEditor.vue?vue&type=template&id=bc1885f6&scoped=true"
import script from "./STextEditor.vue?vue&type=script&lang=js"
export * from "./STextEditor.vue?vue&type=script&lang=js"
import style0 from "./STextEditor.vue?vue&type=style&index=0&id=bc1885f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1885f6",
  null
  
)

export default component.exports